import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import './../../shared/rxjs-operators';
import { LogService, ApiService, CacheService, AppContext } from './../../shared';

@Injectable()
export class SearchBoxService {
  items: Observable<any>;
  favorites = new Array<any>();
  type: string = 'port'; // default

  autoOn = false;
  loaderOn = false;
  noResult = false;

  constructor(private logger: LogService, private api: ApiService, private cache: CacheService, public app: AppContext) {
    // this.logger.log('search-box.service', 'constructor', this.app);
  }

  setType(type: string) {
    this.type = type;
    if (this.type === 'port') {
      this.favorites = this.app.ports;
    } else if (this.type === 'carrier') {
      this.favorites = this.app.carriers;
    } else if (this.type === 'vessel') {
      this.favorites = this.app.vessels;
      for (let current = 0; current < this.favorites.length; current++) {
        this.favorites[current].display = this.favorites[current].name;
      }
    } else {
      this.logger.log('search-box.service', 'setType', 'type is not recognized: ' + this.type);
    }
  }

  search(term: string) {
    if (this.type === 'port') {
      return this.getPorts(term);
    } else if (this.type === 'carrier') {
      //
    } else if (this.type === 'vessel') {
      return this.getVessels(term);
    } else {
      this.logger.log('search-box.service', 'search', 'type is not recognized: ' + this.type);
    }
  }

  startSearch() {
    this.autoOn = true;
    this.loaderOn = true;
    this.noResult = false;
  }

  getPorts(term: string): Observable<any> {
    this.startSearch();
    // let cache = this.cache.get('ports' + term);
    let promise = this.api.getApiClient().then(client => this.callGetPorts(client, term));
    let server = Observable.fromPromise(promise);
    this.items = server;
    // this.ports = Observable.concat(cache, server);
    // this.cache.updateCache('ports' + term, this.ports);

    return this.items;
  }

  callGetPorts(apigClient: any, term: string): Promise<any> {
    this.logger.log('search-box.service', 'callGetPorts', term);
    return new Promise((resolve, reject) => {
      let params = {};
      let additionalParams = {
        // If there are any unmodeled query parameters or headers that must be
        // sent with the request, add them here.
        headers: {
          'Content-Type': 'application/json'
        },
        queryParams: {
          search: term
        }
      };
      try {
        apigClient.portsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('search-box.service', 'resolve', result);
            let formatted = this.endSearch(result.data);
            if (formatted !== null) {
              for (let current = 0; current < formatted.length; current++) {
                let item = formatted[current];
                this.formatPort(item);
              }
            }
            resolve(formatted);
          }).catch((err) => {
            this.endSearch(null);
            this.api.handleError(err);
          });
      } catch (ex) {
        this.logger.log('search-box.service', 'catch', ex);
        return reject(ex);
      }
    });
  }

  formatPort(item: any): any {
    if (item.country !== null && item.country.id === 'US') {
      try {
        item.display = item.name + ' [' + item.code + '], ' + item.region.name + ', ' + item.country.name;
      } catch (ex) {
        if (item.region === null && item.country !== null) {
          item.display = item.name + ' [' + item.code + '], ' + item.country.name;
        } else {
          item.display = item.name + ' [' + item.code + ']';
        }
      }
    } else {
      try {
        item.display = item.name + ' [' + item.code + '], ' + item.country.name;
      } catch (ex) {
        item.display = item.name + ' [' + item.code + ']';
      }
    }
  }

  getVessels(term: string): Observable<any> {
    this.startSearch();
    // let cache = this.cache.get('vessels' + term);
    let promise = this.api.getApiClient().then(client => this.callGetVessels(client, term));
    let server = Observable.fromPromise(promise);
    this.items = server;
    // this.vessels = Observable.concat(cache, server);
    // this.cache.updateCache('vessels' + term, this.vessels);

    return this.items;
  }

  callGetVessels(apigClient: any, term: string): Promise<any> {
    this.logger.log('vessels-search.service', 'callGetVessels', term);
    return new Promise((resolve, reject) => {
      let params = {};
      let additionalParams = {
        headers: {
          'Content-Type': 'application/json'
        },
        queryParams: {
          search: term
        }
      };
      try {
        apigClient.vesselsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('vessels-search.service', 'resolve', result);
            let formatted = this.endSearch(result.data);
            if (formatted !== null) {
              for (let current = 0; current < formatted.length; current++) {
                formatted[current].display = formatted[current].name;
              }
            }
            resolve(formatted);
          }).catch((err) => {
            this.endSearch(null);
            this.autoOn = false;
            this.api.handleError(err);
          });
      } catch (ex) {
        this.logger.log('vessels-search.service', 'catch', ex);
        return reject(ex);
      }
    });
  }

  endSearch(data: any): any {
    if (data === null || data.items === null || data.items === undefined || data.items.length === 0) {
      this.noResult = true;
      this.loaderOn = false;
      return null;
    } else {
      this.noResult = false;
      this.loaderOn = false;
      return data.items;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/search-box/search-box.service.ts